import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/DependencyTree/Inclusion.ts";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.number.constructor.js";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { combine, createEffect, createStore } from 'effector';
import { clone, prop } from 'ramda';
import * as api from '@gmini/sm-api-sdk';
import { isNotEmpty } from '@gmini/utils';
import { isDynamicBimElementReferenceNode, isReferenceNode } from "../../classifier-service/Node";
import { getNode } from "../../classifier-service";
import { getRefFromPathKey } from "../ClassifierTree/utils";
import { getInclusionNodeType } from "./types";
export function createInclusionModel(_ref) {
  var flatTree$ = _ref.flatTree$,
      currentEntity$ = _ref.currentEntity$,
      nodes$ = _ref.nodes$,
      inclusionFilterStatus$ = _ref.inclusionFilterStatus$,
      notification = _ref.notification,
      expanded$ = _ref.expanded$;
  var loadNodeInclusion = createEffect({
    handler: function () {
      var _handler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return api.InclusionStatus.calculate.defaultContext({
                  classifierId: params.id,
                  classifierVersion: params.version
                });

              case 2:
                res = _context.sent;
                return _context.abrupt("return", {
                  items: res.result,
                  cls: {
                    id: params.id,
                    version: params.version
                  }
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function handler(_x) {
        return _handler.apply(this, arguments);
      }

      return handler;
    }()
  }, {
    name: "loadNodeInclusion",
    sid: "le5y8u"
  });
  var loadNodeInclusionByStandardSize = createEffect({
    handler: function () {
      var _handler2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params) {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return api.InclusionStatus.calculateStandardSize.defaultContext({
                  classifierId: params.id,
                  classifierVersion: params.version,
                  standardSizeId: params.standardSizeId,
                  modelVersion: params.modelVersion
                });

              case 2:
                res = _context2.sent;
                return _context2.abrupt("return", {
                  items: res.result,
                  cls: {
                    id: params.id,
                    version: params.version
                  }
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function handler(_x2) {
        return _handler2.apply(this, arguments);
      }

      return handler;
    }()
  }, {
    name: "loadNodeInclusionByStandardSize",
    sid: "4ehlhz"
  });
  var inclusionStatusChangedEvent = notification.filter({
    fn: api.NotificationEvent.InclusionStatusChange.is
  }).map(prop('payload'));
  inclusionStatusChangedEvent.watch(function (_ref2) {
    var classifierId = _ref2.classifierId,
        classifierVersion = _ref2.classifierVersion;
    var expandedStandardSizeIds = getExpandedStandardSizeIds(expanded$.getState());
    var nodes = nodes$.getState();
    var standardSizeNodes = expandedStandardSizeIds.map(function (id) {
      return nodes.BimStandardSizeNode[id];
    }).filter(isNotEmpty);
    Promise.all(standardSizeNodes.map(function (node) {
      return loadNodeInclusionByStandardSize({
        id: classifierId,
        version: classifierVersion,
        modelVersion: node.modelVersion,
        standardSizeId: node.id
      });
    }));
    loadNodeInclusion({
      id: classifierId,
      version: classifierVersion
    });
  });
  var inclusionStore$ = createStore({}, {
    name: "inclusionStore$",
    sid: "-dw07pk"
  }).on(loadNodeInclusion.doneData, function (prev, _ref3) {
    var items = _ref3.items,
        cls = _ref3.cls;
    return updateInclusionState({
      prev: prev,
      items: items,
      cls: cls,
      skipNode: function skipNode(_ref4) {
        var _ref5 = _slicedToArray(_ref4, 1),
            type = _ref5[0];

        return type === 'BimElement';
      }
    });
  }).on(loadNodeInclusionByStandardSize.done, function (prev, _ref6) {
    var params = _ref6.params,
        result = _ref6.result;
    return updateInclusionState({
      prev: prev,
      items: result.items,
      cls: result.cls,
      skipNode: function skipNode(_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
            type = _ref8[0],
            id = _ref8[1];

        if (type !== 'BimElement') {
          return true;
        }

        var node = nodes$.getState().BimElementNode[id];
        return (node === null || node === void 0 ? void 0 : node.standardSizeId) !== params.standardSizeId;
      }
    });
  });
  var currentInclusionMap$ = combine({
    ɔ: [{
      inclusionStore: inclusionStore$,
      currentUserClassifier: currentEntity$
    }, function (_ref9) {
      var inclusionStore = _ref9.inclusionStore,
          currentUserClassifier = _ref9.currentUserClassifier;
      return currentUserClassifier ? inclusionStore[currentUserClassifier.id] : null;
    }],
    config: {
      name: "currentInclusionMap$",
      sid: "-2sjtvr"
    }
  });
  var filteredFlatTree$ = combine({
    ɔ: [{
      dependencyTreeModel: flatTree$,
      inclusionStatus: inclusionFilterStatus$,
      includedCls: currentInclusionMap$
    }, function (_ref10) {
      var dependencyTreeModel = _ref10.dependencyTreeModel,
          includedCls = _ref10.includedCls,
          inclusionStatus = _ref10.inclusionStatus;

      if (!includedCls || inclusionStatus === 'Off') {
        return dependencyTreeModel;
      }

      return dependencyTreeModel.filter(function (_ref11) {
        var _path = _ref11.path,
            ref = _ref11.ref;

        var _node = ref.type === 'LoadMore' ? getNode(nodes$.getState(), ref.parentNodeRef) : getNode(nodes$.getState(), ref);

        var path = ref.type === 'LoadMore' ? _path.slice(0, -1) : _path;
        var key = path[path.length - 1];

        if (!_node || !includedCls) {
          return false;
        }

        var includedMap = getIncludedMap(nodes$.getState(), path, includedCls);

        if (inclusionStatus === 'NotIncluded') {
          var parentOrSelfNotIncluded = !includedMap[key].some(function (value) {
            return value === 'SELF_INCLUDED' || value === 'PARENT_INCLUDED';
          });
          return !includedMap[key].length || parentOrSelfNotIncluded;
        }

        var parentIncluded = Object.keys(includedMap).find(function (val) {
          return val !== key && !!includedMap[val].includes('SELF_INCLUDED');
        });
        var included = parentIncluded ? [].concat(_toConsumableArray(includedMap[key]), ['PARENT_INCLUDED']) : includedMap[key];
        return !!(included !== null && included !== void 0 && included.length);
      });
    }],
    config: {
      name: "filteredFlatTree$",
      sid: "-pxy743"
    }
  });
  return {
    inclusionStore$: inclusionStore$,
    loadNodeInclusion: loadNodeInclusion,
    loadNodeInclusionByStandardSize: loadNodeInclusionByStandardSize,
    currentInclusionMap$: currentInclusionMap$,
    filteredFlatTree$: filteredFlatTree$
  };
}
export function translateInclusionMessage(inclusionStatusWithTranscript, messArr) {
  return messArr.map(function (m) {
    return inclusionStatusWithTranscript[m];
  });
}
export function getInclusionKey(node) {
  var reference = (isReferenceNode(node) || isDynamicBimElementReferenceNode(node)) && node || node.type === 'AssemblyClassifierNode' && node.assemblyModelRef || null;
  return reference ? "".concat(getInclusionNodeType(reference.element.type), "_").concat(reference.element.id) : "".concat(getInclusionNodeType(node.type), "_").concat(node.id);
}

var getInclusion = function getInclusion(key, nodes, inclusionMap) {
  var _node = getNode(nodes, getRefFromPathKey(key));

  if (_node) {
    var included = inclusionMap === null || inclusionMap === void 0 ? void 0 : inclusionMap[getInclusionKey(_node)];
    return included;
  }

  return [];
};

var getIncludedMap = function getIncludedMap(nodes, path, inclusionMap) {
  var includedMap = path.reduce(function (acc, next) {
    acc[next] = getInclusion(next, nodes, inclusionMap) || [];
    return acc;
  }, {});
  return includedMap;
};

var getExpandedStandardSizeIds = function getExpandedStandardSizeIds(expanded) {
  return Object.entries(expanded).reduce(function (acc, _ref12) {
    var _ref13 = _slicedToArray(_ref12, 2),
        key = _ref13[0],
        value = _ref13[1];

    if (value) {
      var path = key.split(':');
      var lastExpandedNode = path[path.length - 1];

      var _lastExpandedNode$spl = lastExpandedNode.split('_'),
          _lastExpandedNode$spl2 = _slicedToArray(_lastExpandedNode$spl, 2),
          lastExpandedNodeType = _lastExpandedNode$spl2[0],
          lastExpandedNodeId = _lastExpandedNode$spl2[1];

      if (lastExpandedNodeType === 'BimStandardSizeNode') {
        acc.push(Number(lastExpandedNodeId));
      }
    }

    return acc;
  }, []);
};

var updateInclusionState = function updateInclusionState(_ref14) {
  var cls = _ref14.cls,
      skipNode = _ref14.skipNode,
      items = _ref14.items,
      prev = _ref14.prev;
  var next = clone(prev);
  var currentItems = next[cls.id] || {};
  var filteredItems = Object.entries(currentItems).reduce(function (acc, _ref15) {
    var _ref16 = _slicedToArray(_ref15, 2),
        key = _ref16[0],
        value = _ref16[1];

    var _key$split = key.split('_'),
        _key$split2 = _slicedToArray(_key$split, 2),
        type = _key$split2[0],
        id = _key$split2[1];

    if (skipNode([type, Number(id)])) {
      acc[key] = value;
    }

    return acc;
  }, {});
  next[cls.id] = items.reduce(function (acc, item) {
    var key = "".concat(item.itemType, "_").concat(item.itemId);
    var prevValue = acc[key] || [];
    acc[key] = [].concat(_toConsumableArray(prevValue), [item.value]);
    return acc;
  }, filteredItems);
  return next;
};